import {http,BaseUtil} from '@zkwq/business'
import {CACHE_KEY} from '../constant'
import {removeToken} from '../service/view/user_power'

// const SetStorage = BaseUtil.setStorage;
// const GetStorage = BaseUtil.getStorage;
// const RemoveStorage = BaseUtil.removeStorage;

let appid = '';
let secret = '';
let redirectUri = '';
// let quitRedirectUri = '';
let is_login_dev;
export let developer_user;
if(process.env.NODE_ENV == 'development'){
    appid = 'xxx123';
    secret = 'xxx000';
    redirectUri = location.protocol + '//' + location.host + '/login';
    // quitRedirectUri = 'http://localhost:8081';
    is_login_dev = true;
    developer_user = {
     // id: 'f0d940dae4324263bbbf201c807ac986',
     id: '67f40dd4d8384746a92ba3cd53a2739b',
     // 67f40dd4d8384746a92ba3cd53a2739b
     name: '系统用户',
     // institution: '测试机构',
     institutionHKY:'测试机构',
     avatar: '',
     email: '1634619456@qq.com',
 };
}else{
    appid = 'hkyki6r7sdel4ay2h9';
    secret = 'b5yoeltxia7jejnh04pikp5tb219xohc';
    // 服务API地址
    // redirectUri = 'http://10.3.11.10:8010/login';
    redirectUri = 'http://datatool.las.ac.cn/login';
    // is_login_dev = false
    is_login_dev = false;
}

export {
    is_login_dev
}

//重新登录
export const loginUrl = `https://scholarin.cn/oauth/authorize?appid=${appid}&redirect_uri=${redirectUri}&scope=api_signin&response_type=code&state=STATE`

export const getAccessToken = (code,callBack) => {
    if(code){
        http.get(`https://scholarin.cn/hky/oauth/access_token?appid=${appid}&secret=${secret}&code=${code}&grant_type=authorization_code`).then(resp => {
            if(resp.failure){
                alert('登录失败,请重试')
                location.href = '/'
            }else{
                getUserInfo(resp.user_id, resp.access_token, callBack);
            }
        }).catch(e => {
            console.error(e)
        })
    }
}
export const getUserInfo = (userId,accessToken, callBack) => {
    http.get(`https://scholarin.cn/hky/scholars/${userId}/base?access_token=${accessToken}`).then(e => {
        callBack && callBack(e)
    }).catch(e => {
        console.error(e)
    });
}

export const toLogin = () => {
    let pathname = location.pathname;
    if (pathname != '/login' && pathname != '/changePassword'){
        saveSession(CACHE_KEY.TARGET_PATH, location.href)
    }
    // location.href = '/login'
    //重新登录
    location.href = loginUrl
}

export const outLogin = (is_force=false) => {
    let user = getSession(CACHE_KEY.USER_INFO) || {}
    let pathname = location.pathname;
    let is_ol = sessionStorage.getItem('is_out_login');
    if(is_ol != 'yes' || is_force){
        if (pathname != '/login' && pathname != '/changePassword'){
            saveSession(CACHE_KEY.TARGET_PATH, location.href)
        }
        removeUser()
        removeToken(user.token, (e) => {
        })
        setTimeout(() => {
            // location.href = '/login'
            let url = encodeURIComponent(`https://scholarin.cn/hky/oauth/logout?appid=${appid}&redirect_uri=${redirectUri}`);
            location.href = `https://passport.escience.cn/logout?WebServerURL=${url}`
        }, 1000);
        sessionStorage.setItem("is_out_login", 'yes')
    }
};

export function checkUser(is_to_login=false) {
    let user = getSession(CACHE_KEY.USER_INFO)
    if(is_to_login && !user){
        //console.log("登录失效")
        //outLogin()
    }
    return user
}


export function getFunctionInfo(user) {
    //获取用户权限
    let funList = user?.functionInfo || {};
    return funList
}

export function removeUser() {
    removeSession(CACHE_KEY.USER_INFO)
}

function getUrlParam(str, def) {
    var query = window.location.search.substring(1);
    query = decodeURIComponent(query);
    var vars = query.split("&");
    for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] == str) { return pair[1]; }
    }
    return def || '';
}

export function getSession(key, type='object') {
    //获取session
    try {
        let str64 = window.localStorage.getItem(key);
        if (str64) {
            let value = str_atob_bate64(str64)
            if(type == 'object'){
                let data = JSON.parse(value);
                return data
            } else {
                return value
            }
        }else {
            return null
        }
    } catch (error) {
        // throw出来的异常，会在下面的第一个catch中捕获到，如此不会尽管发生了错误，也并不会终止整个程序执行
        console.log(error);
    }
}
export function saveSession(key, item,  type='object') {
    // 新增session
    let value;
    if(type == 'object'){
        value = JSON.stringify(item)
    }else {
        value = item
    }
    let str64 = str_btoa_bate64(value);
    window.localStorage.setItem(key, str64)
}
export function removeSession(key) {
    // 删除session
    window.localStorage.removeItem(key)
}

export function str_btoa_bate64(value) {
    //base64 加密
    let str = encodeURIComponent(value)
    str = unescape(str)
    let str64 = window.btoa(str)
    return str64;
}

export function str_atob_bate64(str64) {
    //base64 解密
    let str = escape(window.atob(str64))
    let value = decodeURIComponent(str)
    return value
}
